import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    standalone: true,
    imports: [CommonModule],
    selector: 'app-footer',
    template: `<footer class="layout-footer" aria-label="Pie de página plataforma">
        <div class="foot-inner">
            <span class="copy">© {{ currentYear }} OLDELVAL</span>
            <span class="sep" aria-hidden="true">·</span>
            <span class="made">Desarrollado por <span class="brand">Blister</span></span>
        </div>
    </footer>`
})
export class AppFooter {
    currentYear = new Date().getFullYear();
}
